export enum FilterType {
    Booking = 'booking',
    User = 'user',
    SubAdmin = 'subAdmin',
    Payment='payment'
  }
  